module.exports = __webpack_public_path__ + "img/button.4d602837.png";